import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import './i18n'
import reportWebVitals from './reportWebVitals'
import { AuthProvider } from './context/AuthContext'

import { SnackbarProvider } from 'notistack'
import { LangProvider } from './context/LangContext'
import { MessageProvider } from './context/MessageContext'

// TODO: Comment this line to deactivate Mocking locally!

import { ThemeProvider } from './@airbus/components-react/lib/styling'
import { LightDarkProvider } from 'context/LightDarkModeContext'
import { LoadingProvider } from 'context/LoadingContext'
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
//import 'bootstrap/dist/css/bootstrap.min.css';
//import "@fortawesome/fontawesome-free/css/all.min.css";

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <LangProvider>
      <ThemeProvider>
        <LightDarkProvider>
          <BrowserRouter>
            <SnackbarProvider autoHideDuration={4000}>
              <MessageProvider>
                <AuthProvider>
                  <LoadingProvider>
                    <DndProvider backend={HTML5Backend}>
                      <App />
                    </DndProvider>
                  </LoadingProvider>
                </AuthProvider>
              </MessageProvider>
            </SnackbarProvider>
          </BrowserRouter>
        </LightDarkProvider>
      </ThemeProvider>
    </LangProvider>
  </React.StrictMode>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
